import script from "./AppointmentScheduleDetailsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentScheduleDetailsCard.vue?vue&type=script&setup=true&lang=ts"

import "./AppointmentScheduleDetailsCard.vue?vue&type=style&index=0&id=9e04bb16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e04bb16"]])

export default __exports__